import React, { Component } from "react";

export default class Error extends Component {
  constructor() {
    super();
    this.state = {
      hasError: false,
      error: "",
      errorInfo: "",
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });
    console.log(error);
  }
  render() {
    if (this.state.hasError) {
      return (
        <details style={{ whiteSpace: "pre-wrap" }}>
          {this.state.error && this.state.error.toString()}
          <br />
          {this.state.errorInfo.componentStack}
        </details>
      );
    }
    return this.props.children;
  }
}
